import React from 'react';
import { cn } from '../../../utils/cn';

const STYLES = {
  pending: 'bg-amber-100 text-amber-900 ring-amber-200/70',
  overdue: 'bg-rose-100 text-rose-800 ring-rose-200/70',
  submitted: 'bg-sky-100 text-sky-800 ring-sky-200/70',
  paid: 'bg-emerald-100 text-emerald-800 ring-emerald-200/70',
};

const LABELS = {
  admin: { pending: 'Fee pending', overdue: 'Overdue', submitted: 'Verify payment', paid: 'Paid' },
  payer: {
    pending: 'Due',
    overdue: 'Overdue',
    submitted: 'Awaiting verification',
    paid: 'Paid',
  },
};

/** `audience="admin"` reads as a to-do ("Verify payment"); `payer` reads as status for students/parents. */
export function FeeStatusBadge({
  status,
  overdue = false,
  audience = 'admin',
  className,
  children,
}) {
  if (!status) return null;
  const key = status === 'pending' && overdue ? 'overdue' : status;
  return (
    <span
      className={cn(
        'inline-flex shrink-0 items-center gap-1 whitespace-nowrap rounded-full px-2 py-0.5 text-[10px] font-bold ring-1 ring-inset sm:text-xs',
        STYLES[key] || 'bg-slate-100 text-slate-700 ring-slate-200/70',
        className
      )}
    >
      {children ?? LABELS[audience]?.[key] ?? status}
    </span>
  );
}
